import {Store} from "@ngrx/store";
import {IEventsDefAndSelectedState} from "@ispm-client/modules/events/Interfaces";
import {Injectable} from "@angular/core";
import {Subject, Observable} from "rxjs";

@Injectable()
export class EventValidationWizardService {


  public store$: Store<IEventsDefAndSelectedState>;
  private nlpHighlights: any;
  private invoke = new Subject();
  private _reviewExtractionKey: any;

  constructor(private store: Store<any>) {
    this.store$ = store.select('events') as any;
  }

  public setNLPHighlights(value) {
    this.nlpHighlights = value;
  }

  getNLPHighlights(): any {
    return this.nlpHighlights;
  }

  sendEvent() {
    this.invoke.next();
  }

  getEvent(): Observable<any> {
    return this.invoke.asObservable();
  }

  getReviewExtractionKey(): any {
    return this._reviewExtractionKey;
  }

  setReviewExtractionKey(value: any) {
    this._reviewExtractionKey = value;
  }


}
